/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Row, Col } from 'react-bootstrap';
import {
  useForm,
  FieldValues,
  SubmitHandler,
  Controller
} from 'react-hook-form';
import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { useTranslation } from 'react-i18next';

import Button from 'components/base/Button';
import { showAlert } from 'store/alert/alert.thunk';
import favoriteService from 'service/favorite';

interface AddCatalogProps {
  refetch: any;
  setIsOpenAddToCategory?: (show: boolean) => void;
}

const AddCatalog = ({ refetch, setIsOpenAddToCategory }: AddCatalogProps) => {
  const { t } = useTranslation();
  const dispatch: Dispatch<any> = useDispatch();
  const inputRef = useRef<HTMLInputElement | any>();

  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm();

  const focusInput = () => {
    if (inputRef.current) {
      inputRef.current.focus();
      setTimeout(() => inputRef.current?.select(), 300);
    }
  };

  const onSubmit: SubmitHandler<FieldValues> = data => {
    setLoading(true);
    favoriteService
      .createFavoriteCatalog({ name: data?.name })
      .then(() => {
        refetch();
        setIsOpenAddToCategory?.(false);
        setLoading(false);
        dispatch(
          showAlert({
            title: `${t('successfully_added')}`,
            type: 'success'
          })
        );
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    focusInput();
  }, []);

  return (
    <>
      <Form
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        <Row className="mb-3">
          <Col>
            <Controller
              name={`name`}
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Form.Floating className="md-4">
                  <Form.Control
                    {...field}
                    ref={inputRef}
                    type="text"
                    placeholder={t('main_name')}
                    onFocus={e => e.target.select()}
                    isInvalid={!!errors.name}
                  />
                  <label htmlFor="floatingInputCustom">{t('main_name')}</label>
                  {errors.name && (
                    <Form.Control.Feedback type="invalid">
                      {t('required_field')}
                    </Form.Control.Feedback>
                  )}
                </Form.Floating>
              )}
            />
          </Col>
        </Row>

        <Button
          style={{ height: '48px', marginTop: 'auto' }}
          variant="primary"
          type="submit"
          loading={loading}
          loadingPosition="start"
        >
          {t('add')}
        </Button>
      </Form>
    </>
  );
};

export default AddCatalog;
